import React, {Fragment} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {
    Card,
    Button,
    Grid,
} from '@material-ui/core';
import {caseAccept, caseReject} from '../../vendors/actions/case'
import DescriptionBox from '../../elements/descriptionBox/descriptionBox'
import LawyerBox from "../../elements/lawyerBox/lawyerBox";
import {CheckIcon, RejectIcon} from "../../elements/svgIcons";

interface OwnProps {
    data: any,
    caseAccept?: any,
    rejectCase?: any
    caseState?: Object
}

interface ConnectStateProps {
    States: any,
    CaseTypes: any,
    User: {
        first_name: string;
        last_name: string;
        isAuthenticated?: boolean;
    }
}

interface ConnectDispatchProps {
    caseAccept?: (data: any) => void;
    caseReject?: (data: any) => void;
}

const InterestedLawyer = (props: any) => {
    const {data, States, caseState} = props,
        {Lawyer, lawyer_id} = data,
        lawyerState = Lawyer.States.find((st: any) => st.state === caseState.id);

    if (lawyerState) {
        Lawyer.States = [lawyerState]
    }
    Lawyer.States = Lawyer.States ? Lawyer.States.map((st: any) => {
        const state = States.find((state: any) => st.state === state.id);
        return {
            ...state,
            ...st
        };
    }) : [];

    const accept = () => props.caseAccept({lawyer_id});

    const reject = () => props.caseReject({lawyer_id});

    return (
        <Fragment>
            <Card className="my-3 my-lg-2 interested-lawyer" variant="outlined">
                <Grid container className="mb-3">
                    <Grid item xs={12} lg={4} className='d-flex px-1 px-lg-0'>
                        <LawyerBox data={Lawyer}/>
                    </Grid>
                    <Grid item xs={12} lg={7} className='pt-3 pt-lg-0'>
                        <DescriptionBox data={{text: data.comment, description: 'Proposal', className: 'min-height interested-lawyer-box'}}/>
                        <div className='d-flex justify-content-end buttons-wrapper'>
                            <Button
                                onClick={accept}
                                color="primary"
                                variant="contained"
                                size='small'
                                className="mr-3 text-capitalize accept-btn">
                                <span className="btn-wrapper--icon">
                                     <CheckIcon style={{fontSize: '.857rem'}}/>
                                </span>
                                <span className="btn-wrapper--label font-size-md">Accept</span>
                            </Button>
                            <Button
                                onClick={reject}
                                color="default"
                                size='small'
                                variant="outlined"
                                className="text-black-50 text-capitalize reject-btn">
                                <span className="btn-wrapper--icon">
                                     <RejectIcon style={{fontSize: '.643rem'}}/>
                                </span>
                                <span className="btn-wrapper--label">Reject</span>
                            </Button>
                        </div>
                    </Grid>
                </Grid>
            </Card>
            <div className='d-lg-none divider lawyers-divider'></div>
        </Fragment>
    );
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, Layout, CaseTypes, States} = state;
    return {
        User,
        Layout,
        States,
        CaseTypes
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        caseReject: (data: any) => dispatch(caseReject(data)),
        caseAccept: (data: any) => dispatch(caseAccept(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(InterestedLawyer);
